import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Parcel } from 'app/core/app.model';
import { SummaryData } from 'app/core/summary-sheet/summary-sheet.model';
import { AsyncItem } from 'app/shared/async-item';
import { _localStorage } from 'app/shared/utils';
import { Report } from '../report/report.model';


export interface PropertyItem {
    parcel: Parcel;
    table: { [columnKey: string]: AsyncItem };
    report?: Report;
    summary?: SummaryData;
}

export interface State {
    selectedColumns: string[];
    favoriteColumns: string[];
    loaded: boolean;
    properties: PropertyItem[];
    showLtsaBadCredentialsToast: boolean;
}

export const initialState: State = {
    selectedColumns: [],
    favoriteColumns: JSON.parse(_localStorage.getItem('propertyTableRecentColumnSelection') || '[]'),
    loaded: false,
    properties: [],
    showLtsaBadCredentialsToast: true,
};

const base = createFeatureSelector<State>('properties');

export const getPropertyItemByUpid = (upid: string) => createSelector(base, state => state.properties.find(p => p.parcel.upid === upid));

export const getLtsaCredentialsNotification = createSelector(base, state => state.showLtsaBadCredentialsToast);
